export function extractErrorMessages(payload: unknown, fallbackMessage: string): string[] {
  const messages: string[] = [];

  const pushMessage = (value: unknown) => {
    if (!value) {
      return;
    }
    const str = String(value).trim();
    if (!str) {
      return;
    }
    if (!messages.includes(str)) {
      messages.push(str);
    }
  };

  if (payload && typeof payload === 'object' && 'errorMsg' in payload) {
    pushMessage((payload as { errorMsg?: unknown }).errorMsg);
  }

  const model = payload && typeof payload === 'object' && 'model' in payload
    ? (payload as { model?: unknown }).model
    : null;

  if (Array.isArray(model)) {
    model.forEach(pushMessage);
  } else if (model && typeof model === 'object') {
    Object.values(model as Record<string, unknown>).forEach((value) => {
      if (Array.isArray(value)) {
        value.forEach(pushMessage);
        return;
      }
      if (typeof value === 'string' && value.includes(',')) {
        value.split(',').forEach(pushMessage);
        return;
      }
      pushMessage(value);
    });
  } else if (model !== null && model !== undefined) {
    pushMessage(model);
  }

  if (typeof payload === 'string') {
    pushMessage(payload);
  }

  if (!messages.length) {
    pushMessage(fallbackMessage);
  }

  return messages;
}
